// Universal widget registry. The MatterDashboard renderer looks up
// `template.ui.widgets[i].type` here and renders the matching component.
// Unknown types fall back to a "Coming soon" placeholder so a template
// authored ahead of widget-impl never breaks the page.

import type { FC } from "react";
import { BailStatusWidget } from "./BailStatusWidget";
import { DeadlineStripWidget, DeadlineWidget } from "./DeadlineWidget";
import { DemandValueWidget } from "./DemandValueWidget";
import { DocChecklistWidget } from "./DocChecklistWidget";
import { FamilyTreeWidget } from "./FamilyTreeWidget";
import { MetricWidget } from "./MetricWidget";
import { MotionListWidget } from "./MotionListWidget";
import { PartiesStripWidget } from "./PartiesStripWidget";
import { StageFunnelWidget } from "./StageFunnelWidget";
import { TreatmentStatusWidget } from "./TreatmentStatusWidget";
import {
  COIWidget,
  ChargesWidget,
  DeclarationWidget,
  I589Widget,
  PleaWidget,
  SentencingWidget,
} from "./legacyAdapters";
import type { WidgetProps } from "./types";

export type { WidgetProps } from "./types";
export { WidgetCard } from "./WidgetCard";

export const WIDGETS: Record<string, FC<WidgetProps>> = {
  // Generic
  metric: MetricWidget,
  deadline: DeadlineWidget,
  deadline_strip: DeadlineStripWidget,
  stage_funnel: StageFunnelWidget,
  doc_checklist: DocChecklistWidget,
  parties_strip: PartiesStripWidget,

  // Per-area generic
  bail_status: BailStatusWidget,
  treatment_status: TreatmentStatusWidget,
  demand_value: DemandValueWidget,
  family_tree: FamilyTreeWidget,
  motion_list: MotionListWidget,

  // Wrapped legacy cards
  i589_card: I589Widget,
  declaration_card: DeclarationWidget,
  coi_card: COIWidget,
  charges_panel: ChargesWidget,
  plea_status: PleaWidget,
  sentencing_card: SentencingWidget,
};

export type WidgetTypeId = keyof typeof WIDGETS;
